import Request from 'superagent';

var api = {
    AccountService(requestObj){
        return Request.get('/cfcs/accountService.cfc?')
            .query(requestObj)
    },
    
    StoreService(requestObj){
        return Request.get('/cfcs/storeService.cfc?')
            .query(requestObj)  
    },
    
    AdService(requestObj){
        return Request.get('/cfcs/adService.cfc?')
            .query(requestObj)  
    },
	Connect(requestObj) {
		return Request.get('/cfcs/stripeConnect.cfc?')
            .query(requestObj)  
	},
    General(url, requestObj){
        return Request.get(url)
            .query(requestObj)
    },
	Stripe: {
		charge: (sendData) => {
			api.General('/includes/actChargeCard.cfm', sendData).end((err, res) => {
				return JSON.parse(res.text);
			})
		},
		validRoutingNumber: (routingNumber) => {
			return Stripe.bankAccount.validateRoutingNumber(routingNumber, 'US');
		},
		validBankAccountNumber: (accountNumber) => {
			return Stripe.bankAccount.validateAccountNumber(accountNumber, 'US')
		},
		validCardNumber: (cardNumber) => {
			return Stripe.card.validateCardNumber(cardNumber);
		},
		validExpiryDate: (month, year) => {
			return Stripe.card.validateExpiry(month, year)
		},
		validCVC: (CVC) => {
			return Stripe.card.validateCVC(CVC)
		},
		getCardType: (cardNumber) => {
			return Stripe.card.cardType(cardNumber);	
		},
		getBankToken: (RoutingNumber, AccountNumber, callback) => {
			Stripe.bankAccount.createToken({
				country: 'US',
				routingNumber: RoutingNumber,
				accountNumber: AccountNumber
			}, callback);
		},
		getCardToken: (cardData, callback) => {
			
			Stripe.card.createToken({
				name: cardData.name,
				number: cardData.number,
				cvc: cardData.cvc,
				exp_month: cardData.exp_month,
				exp_year: cardData.exp_year,
				address_line1: cardData.address_line1,
				address_line2: cardData.address_line2,
				address_city: cardData.address_city,
				address_state: cardData.address_state,
				address_zip: cardData.address_zip
			}, callback);
		}
		
			
			
	}
}

export default api;


/** WEBPACK FOOTER **
 ** ./app/api/api.js
 **/